import * as a from './Styledfooter.js';

function Footer() {
  
  return (
    <a.FooterWrap>
        푸터에뭐넣을꺼?
    </a.FooterWrap>
  );
}

export default Footer;